/**
 * 是否是安卓系统
 */
export function isAndroid(): boolean {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  let isAndroid: boolean = ua.includes('android');
  return isAndroid;
}

/**
 * 潘墩是否是ios系统
 */
export function isIOS(): boolean {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  const iosDevices: string[] = ['iphone', 'ipad', 'ipod'];
  return iosDevices.some((device) => ua.includes(device));
}

/**
 * 是否在APP内部
 */
export function isInApp(): boolean {
  if (!navigator || !navigator.userAgent) {
    return false;
  }
  const ua: string = navigator.userAgent.toLowerCase();
  return ua.includes('hrhg_new_');
}

/**
 * 判断是不是json字符串
 */
export function isValidJSON(text: string): boolean {
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
}
